module.exports = __webpack_public_path__ + "static/img_9723-5543852a21990e477f94b1951da3ea44.webp";